import { FaEye, FaRegEdit, FaTrashAlt, FaPlus } from "react-icons/fa";
import Pagination from '@mui/material/Pagination';
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import ButtonIcon from "components/ButtonIcon";
import FormSearch from "components/FormSearch";
import TableComponent from "components/Table";
import { TourTypeWrapper } from "./styled"
import { tourTypeSelector } from 'redux/selector'
import { tourTypeActions } from 'redux/slice/tourTypeSlice'
import useDebounce from 'hooks/useDebounce'
import Modal from "./Modal";
import Loading from "components/Loading";

const TourType = () => {
    document.title = 'Quản lý loại tour'
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const qPage = query.get("page")
    const navigate = useNavigate()

    const [showModal, setShowModal] = useState(false)
    const [currentPage, setCurrentPage] = useState(qPage ? parseInt(qPage) : 1)
    const [queryInput, setQueryInput] = useState('')
    const tourTypeState = useSelector(tourTypeSelector)
    const dispatch = useDispatch()
    const querySearch = useDebounce(queryInput, 500)
    const [method, setMethod] = useState('add')
    const [selectedId, setSelectedId] = useState(null)
    const [totalItemInPage, setTotalItemInPage] = useState(0)

    useEffect(() => {
        dispatch(tourTypeActions.getTourType({ query: querySearch, currentPage: currentPage }))
    }, [querySearch, currentPage, dispatch])

    const handleChangeSearchInput = (e) => {
        if (currentPage > 1) {
            setCurrentPage(1)
            navigate(`/admin/tour-type?page=1`)
        }
        setQueryInput(e.target.value)
    }
    const handleChangePaginate = (event, pageNumber) => {
        setCurrentPage(pageNumber)
        navigate(`/admin/tour-type?page=${pageNumber}`)
    }

    const handleHiddenForm = () => {
        setSelectedId(null)
        setShowModal(!showModal)
    }

    const handleShowAddModal = () => {
        setMethod('add')
        setShowModal(!showModal)
    }

    const handleShowUpdateModal = (selectedId) => {
        setSelectedId(selectedId)
        setMethod('update')
        setShowModal(!showModal)
    }

    const handleShowRemoveModal = (selectedId) => {
        setSelectedId(selectedId)
        setMethod('remove')
        setShowModal(!showModal)
    }

    const columns = [
        {
            title: 'Mã loại tour',
            dataIndex: 'id',
            key: 'id',
            align: "center"
        },
        {
            title: 'Tên loại tour',
            dataIndex: 'name',
            key: 'name',
            align: "center"
        },
        {
            title: 'Ngày tạo',
            dataIndex: 'created_at',
            key: 'created_at',
            align: "center"
        },
        {
            title: 'Thao tác',
            key: 'action',
            align: 'center',
            render: (_, { id }) => (
                <>
                    <ButtonIcon
                        onClick={() => handleShowUpdateModal(id)}
                        icon={<FaRegEdit />}
                        description='Sửa'
                        classButton="action-danger-2 btn-action"
                    />
                    <ButtonIcon
                        onClick={() => handleShowRemoveModal(id)}
                        icon={<FaTrashAlt />}
                        description='Xóa'
                        classButton="action-danger btn-action"

                    />
                </>
            ),
        },
    ];

    useMemo(() => {
        if (currentPage > 1) {
            setTotalItemInPage((currentPage - 1) * 5 + tourTypeState.tourTypeList.length)
        }
        else {
            setTotalItemInPage(tourTypeState.tourTypeList.length)
        }
    }, [currentPage, tourTypeState.tourTypeList.length])

    return (
        <TourTypeWrapper className="admin_tour_type">
            <div className="admin_tour_type_control py-0 px-15">
                <div></div>
                {/* <FormSearch
                    placeholder='Tìm kiếm loại tour...'
                    queryInput={queryInput}
                    onChange={handleChangeSearchInput}
                    setQueryInput={setQueryInput}
                /> */}
                <div className="admin_tour_type_control_sort-add">
                    <ButtonIcon
                        onClick={handleShowAddModal}
                        icon={<FaPlus />}
                        description="Thêm mới"
                        classButton="btn_add action-danger-1"
                    />
                </div>
            </div>
            <div className="admin_tour_type_table">
                {
                    tourTypeState.isFetching &&
                    < Loading />
                }
                <TableComponent
                    columns={columns}
                    data={tourTypeState.tourTypeList}
                />
            </div>
            {
                tourTypeState.tourTypeList.length > 0 &&
                <div className="admin_tour_type_pagination mt-15 px-15">
                    <span className="admin_tour_type_pagination_total_item medium">
                        {totalItemInPage} / {tourTypeState.totalItem}
                    </span>
                    {
                        tourTypeState.totalPage > 1 &&
                        <Pagination count={tourTypeState.totalPage} color="primary"
                            onChange={(event, pageNumber) => handleChangePaginate(event, pageNumber)}
                            page={currentPage}
                        />
                    }
                </div>
            }
            <Modal
                selectedId={selectedId}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                querySearch={querySearch}
                showModal={showModal}
                hidden={handleHiddenForm}
                method={method}
            />
        </TourTypeWrapper>
    );
}

export default TourType;